import { Reveal } from "../components/Reveal";
import TestimonialSlider from "../components/TestimonialSlider";

export default function TestimonialsSection() {
  return (
    <section className="bg-[#0a0a0a] text-white border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal className="mb-14 md:mb-20">
          <p className="text-sm text-neutral-500">What agents say</p>
        </Reveal>
        <Reveal delay={0.1}><TestimonialSlider /></Reveal>
      </div>
    </section>
  );
}
